import { CSSProperties } from 'react';

const DOT_COUNT = 12;

const OrbitDotsSpinner = (): JSX.Element => (
    <div className="orbit-dots">
        {Array.from({ length: DOT_COUNT }, (_, i) => (
            <div
                key={i}
                className="orbit-dots__dot"
                style={{
                    transform: `rotate(${(360 / DOT_COUNT) * i}deg)`,
                    '--orbit-dots-scale': `${0.15 + (i / DOT_COUNT) * 0.85}`,
                } as CSSProperties}
            />
        ))}
    </div>
);

export default OrbitDotsSpinner;
